export default __webpack_public_path__ + "static/media/real-time-tracking.f7ac96f6.jpeg";